export default __webpack_public_path__ + "static/media/prince.eefbacea.jpeg";